/** Traductions ligne produit virtualisée inventaire (FR / AR) */
export const virtualizedProductRowFr = {
  noImage: 'N/D',
  editProduct: 'Modifier Produit',
  deleteProduct: 'Supprimer Produit'
};

export const virtualizedProductRowAr = {
  noImage: 'بدون',
  editProduct: 'تعديل المنتج',
  deleteProduct: 'حذف المنتج'
};
